import get from 'lodash/get';
import { createSelector } from 'reselect';
export const selectRawExtraFields = state => state.domainContacts.extraFields;
export const selectRawTldsInfos = state => state.domainContacts.tldsInfos;
export const selectTldInfo = createSelector(selectRawTldsInfos, (state, props) => props, (rawTldsInfo, props) => get(rawTldsInfo, props.fqdn, {}));